import {
  InternalViewModel, StringPropertyViewModel, GuidPropertyViewModel, EnumPropertyViewModel, BoolPropertyViewModel, NumericPropertyViewModel, DateTimeOffsetPropertyViewModel, DateTimePropertyViewModel,
  NNumericPropertyViewModel, NDateTimeOffsetPropertyViewModel, NDateTimePropertyViewModel
} from '@nts/std';
import { AccommodationData } from '../../domain-models/accommodation-data';
import { ReceiptParamsIdentity } from '../../domain-models/receipt-params.identity';

export class GeneratedAccommodationDataViewModel extends InternalViewModel<AccommodationData, ReceiptParamsIdentity> {

  private _id: NumericPropertyViewModel<number>;

  public get id(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._id = value; }, this._id, 'id');
  }

  private _peopleQuantity: NumericPropertyViewModel<number>;

  public get peopleQuantity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._peopleQuantity = value; }, this._peopleQuantity, 'peopleQuantity');
  }

  private _nightQuantity: NumericPropertyViewModel<number>;

  public get nightQuantity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._nightQuantity = value; }, this._nightQuantity, 'nightQuantity');
  }

}
